import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Florida.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Forging Florida's Digital Frontier With Cutting-Edge Mobile
              Applications
            </h2>
            <p>
              Our knowledge merges unmatchable development skills, strategic
              plannings, and seamless deployment practices. As a leading app
              development company in Florida, we focus on delivering digital
              solutions that 2x the revenue of the businesses – in short, giving
              them an instant boost!
            </p>
            <p>
              Our experienced app developers and designers in Miami, Florida can
              power localized app development to bring a wide range of app ideas
              to life ranging from City-based apps to ride sharing, food
              delivery to rating portal apps, and social media platforms,
              Tekrevol makes them all! Start your digital transformation journey
              today with TekRevol and redefine your business in the digital
              future.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
